// React
import React from 'react';
import config from 'config';
import { Link } from 'react-router-dom';
import appRouter from '../../utils/appRouter';
import { FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';

import Utils from '../../utils/utils';

class FooterMenu extends React.Component {
	constructor(props) {
		super(props);
	}

	isPath(path) {
		let regex = new RegExp('/' + path);
		return regex.test(this.props.location.pathname);
	}

	render() {
		const isError = this.isPath('error');
		let menuArr = [...config.application.mainMenuFooter];
		isError ? menuArr.splice(1, 3) : menuArr.splice(0, 1);

		return (
			<ul className="nav nav-tabs">
				{menuArr && menuArr.map(function (item, i) {
					let last = (i == menuArr.length - 1) ? 'last' : '';
					const isExternal = ['privacyPortal', 'privacyPolicy'].includes(item);

					return <li className={last} key={i}>
						<Link to={!isExternal && appRouter.getLink(item)} onClick={() => {
							if (isExternal) {
								window.open(appRouter.getLink(item, true), '_blank');
							} else {
								if (item == 'game') Utils.gaSend('Assinatura', 'Rodapé', 'Jogar');
								appRouter.gaPageView(item);
							}
						}
						}>
							<FormattedHTMLMessage id={"header.menu." + item} />
						</Link>
					</li>;
				})}
			</ul>
		);
	}
}


const mapStateToProps = function (store) {
	return {
		location: store.locationState.location,
		menu: store.menuState
	};
};

export default connect(mapStateToProps)(FooterMenu);


// WEBPACK FOOTER //
// ./src/components/core/footerMenu.component.jsx